import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'displayMultiLine' })
export class DisplayMultilinePipe implements PipeTransform {
  transform(data: any): any {
    return data ? data.replace(new RegExp('\n', 'g'), '<br />') : '';
  }
}
